import { render } from "./Dot.vue?vue&type=template&id=e203736e"
import script from "./Dot.vue?vue&type=script&lang=js"
export * from "./Dot.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__